import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { WorkflowSearchText } from './SearchText';
import { selectWorkflowsFilter } from '../selectors';

const Container = styled.div`
  width: 100%;
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WorkflowsSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    if (!this.props.filter) return null;
    return (
      <Container width={window.innerWidth}>
        <div className="container-fluid p-0">
          <div className="container-fluid ps-0 pe-0 pt-2 pb-0">
            <div className="row p-0 m-0 align-items-center">
              {window.innerWidth > 768 && (
                <div className="col-7 col-sm-8 mb-3 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                  <WorkflowSearchText filter={this.props.filter} />
                </div>
              )}
              {window.innerWidth <= 768 && (
                <>
                  <WorkflowSearchText filter={this.props.filter} />
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

WorkflowsSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectWorkflowsFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowsSearch = compose(withConnect, withRouter)(WorkflowsSearchComp);
